import React from 'react'
import PropTypes from 'prop-types'
import './bookingDotComLink.css'
import bookingDotcomLogo from './bookingdotcom-logo.png'

const BookingDotComLink = ({url, text, subtext}) => {
  return (
    <div className="booking-dotcom-link-container">
      <a href={url} target="_blank">
        <div className="booking-dotcom-link">
          <div className="logo">
            <img src={bookingDotcomLogo} alt="Booking Dot Com Logo" />
          </div>
          <div className="price">
            <span className="text">{text}</span>{' '}
            <span className="sub-text">{subtext}</span>
          </div>
        </div>
      </a>
    </div>
  )
}

BookingDotComLink.propTypes = {
  url: PropTypes.string.isRequired,
}

export default BookingDotComLink



// WEBPACK FOOTER //
// ./src/components/BookingDotComLink/BookingDotComLink.js